import { ErrorHandler, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppInsights } from '@navfleet/shared/app-insights';

export class GlobalErrorHandler extends ErrorHandler {
    private readonly router = inject(Router);

    public override handleError(error: any): void {
        const url = this.router.url;

        AppInsights.trackException(error, { url });

        super.handleError(error);
    }
}
